export const STATE_CITY = {
  "1": {
    state_id: "1",
    state_name: "Andaman and Nicobar Islands",
    cities: {
      "458": "North And Middle Andaman",
      "896": "Nicobar",
      "10036": "South Andaman"
    }
  },
  "2": {
    state_id: "2",
    state_name: "Andhra Pradesh",
    cities: {
      "23": "Anantapur",
      "35": "Cuddapah",
      "69": "Nellore",
      "233": "East Godavari",
      "267": "Kurnool",
      "314": "Srikakulam",
      "324": "Visakhapatnam",
      "381": "West Godavari",
      "401": "Vizianagaram",
      "475": "Chittoor",
      "706": "Krishna",
      "775": "Prakasam"
    }
  },
  "3": {
    state_id: "3",
    state_name: "Arunachal Pradesh",
    cities: {
      "597": "Changlang",
      "622": "Dibang Valley",
      "629": "East Kameng",
      "631": "East Siang",
      "708": "Kurung Kumey",
      "715": "Lohit",
      "717": "Lower Dibang Valley",
      "718": "Lower Subansiri",
      "764": "Papum Pare",
      "828": "Tawang",
      "834": "Tirap",
      "841": "Upper Siang",
      "842": "Upper Subansiri",
      "10034": "West Kameng",
      "10035": "West Siang"
    }
  },
  "4": {
    state_id: "4",
    state_name: "Assam",
    cities: {
      "93": "Tinsukia",
      "139": "Jorhat",
      "153": "Nagaon",
      "218": "Bongaigaon",
      "230": "Dibrugarh",
      "243": "Golaghat",
      "292": "Lakhimpur",
      "335": "Sibsagar",
      "416": "Karimganj",
      "418": "Hailakandi",
      "419": "Cachar",
      "481": "Goalpara",
      "511": "Nalbari",
      "572": "Barpeta",
      "610": "Darrang",
      "618": "Dhemaji",
      "621": "Dhubri",
      "671": "Kamrup",
      "679": "Karbi Anglong",
      "700": "Kokrajhar",
      "733": "Marigaon",
      "820": "Sonitpur",
      "10037": "Dahotia",
      "10038": "North Cachar Hills"
    }
  },
  "5": {
    state_id: "5",
    state_name: "Bihar",
    cities: {
      "75": "Patna",
      "112": "Bhagalpur",
      "126": "Gaya",
      "165": "Purnia",
      "206": "Begusarai",
      "228": "Darbhanga",
      "283": "Muzaffarpur",
      "289": "Nawadah",
      "311": "Siwan",
      "359": "Samastipur",
      "365": "Nalanda",
      "557": "Araria",
      "568": "Banka",
      "580": "Bhojpur",
      "588": "Buxar",
      "627": "East Champaran",
      "645": "Gopalganj",
      "658": "Jamui",
      "661": "Jehanabad",
      "669": "Bhabua",
      "683": "Katihar",
      "688": "Khagaria",
      "697": "Kishanganj",
      "710": "Lakhisarai",
      "720": "Madhepura",
      "721": "Madhubani",
      "742": "Munger",
      "789": "Rohtas",
      "792": "Saharsa",
      "798": "Saran",
      "809": "Sheikhpura",
      "810": "Sheohar",
      "818": "Sitamarhi",
      "825": "Supaul",
      "845": "Vaishali",
      "1539": "Aurangabad",
      "10039": "Arwal",
      "10040": "West Champaran"
    }
  },
  "6": {
    state_id: "6",
    state_name: "Chandigarh",
    cities: {
      "1": "Chandigarh"
    }
  },
  "7": {
    state_id: "7",
    state_name: "Chhattisgarh",
    cities: {
      "77": "Raipur",
      "204": "Bastar",
      "215": "Bilaspur",
      "521": "Raigarh",
      "523": "Rajnandgaon",
      "609": "Dantewada",
      "616": "Dhamtari",
      "626": "Durg",
      "659": "Janjgir",
      "660": "Jashpur",
      "673": "Kanker",
      "686": "Kawardha",
      "703": "Koriya",
      "723": "Mahasamund",
      "747": "Narayanpur",
      "826": "Surguja",
      "1540": "Bijapur",
      "10041": "Gariaband"
    }
  },
  "8": {
    state_id: "8",
    state_name: "Dadra and Nagar haveli",
    cities: {
      "456": "Dadra and Nagar Haveli"
    }
  },
  "9": {
    state_id: "9",
    state_name: "Daman and Diu",
    cities: {
      "454": "Daman",
      "10042": "Diu"
    }
  },
  "10": {
    state_id: "10",
    state_name: "Delhi",
    cities: {
      "157": "New Delhi"
    }
  },
  "11": {
    state_id: "11",
    state_name: "Goa",
    cities: {
      "291": "Goa"
    }
  },
  "12": {
    state_id: "12",
    state_name: "Gujarat",
    cities: {
      "28": "Baruch",
      "29": "Bhavnagar",
      "51": "Jamnagar",
      "54": "Junagadh",
      "78": "Rajkot",
      "91": "Surat",
      "98": "Vapi",
      "108": "Anand",
      "125": "Gandhinagar",
      "186": "Vadodara",
      "269": "Mahesana",
      "288": "Navsari",
      "298": "Porbandar",
      "360": "Banaskantha",
      "453": "Surendranagar",
      "538": "Valsad",
      "554": "Amreli",
      "606": "Dahod",
      "668": "Kachchh",
      "689": "Kheda",
      "748": "Narmada",
      "761": "Panchmahal",
      "766": "Patan",
      "791": "Sabarkantha",
      "830": "The Dangs",
      "1078": "Tapi"     
    }
  },
  "13": {
    state_id: "13",
    state_name: "Haryana",
    cities: {
      "21": "Ambala",
      "39": "Faridabad",
      "45": "Hissar",
      "81": "Rohtak",
      "101": "Yamunanagar",
      "161": "Panipat",
      "169": "Rewari",
      "177": "Sirsa",
      "212": "Bhiwani",
      "237": "Fatehabad",
      "260": "Karnal",
      "268": "Kurukshetra",
      "295": "Panchkula",
      "333": "Kaithal",
      "433": "Jhajjar",
      "434": "Jind",
      "550": "Sonipat",
      "725": "Mahendragarh"
    }
  },
  "14": {
    state_id: "14",
    state_name: "Himachal Pradesh",
    cities: {
      "55": "Kangra",
      "89": "Solan",
      "149": "Mandi",
      "308": "Shimla",
      "501": "Kullu",
      "535": "Una",
      "590": "Chamba",
      "695": "Kinnaur",
      "709": "Lahul And Spiti",
      "816": "Sirmaur",
      "891": "Bilaspur",
      "937": "Hamirpur"
    }
  },
  "15": {
    state_id: "15",
    state_name: "Jammu and Kashmir",
    cities: {
      "136": "Jammu",
      "179": "Srinagar",
      "320": "Udhampur",
      "427": "Anantnag",
      "467": "Baramulla",
      "585": "Budgam",
      "624": "Doda",
      "680": "Kargil",
      "682": "Kathua",
      "707": "Kupwara",
      "774": "Poonch",
      "777": "Pulwama",
      "782": "Rajauri",
      "10043": "Kulgam",
      "10044": "Reasi"
    }
  },
  "16": {
    state_id: "16",
    state_name: "Jharkhand",
    cities: {
      "36": "Dhanbad",
      "44": "Hazaribagh",
      "118": "Bokaro",
      "167": "Ranchi",
      "232": "Dumka",
      "426": "Deoghar",
      "450": "Ramgarh",
      "598": "Chatra",
      "640": "Garhwa",
      "643": "Giridh",
      "644": "Godda",
      "648": "Gumla",
      "657": "Jamtara",
      "699": "Koderma",
      "712": "Latehar",
      "714": "Lohardaga",
      "759": "Pakur",
      "760": "Palamau",
      "793": "Sahibganj",
      "805": "Seraikela",
      "815": "Simdega",
      "1541": "Singhbhum"
    }
  },
  "17": {
    state_id: "17",
    state_name: "Karnataka",
    cities: {
      "27": "Belgaum",
      "32": "Bijapur",
      "42": "Gulbarga",
      "47": "Hubli",
      "65": "Mysore",
      "87": "Shimoga",
      "95": "Tumkur",
      "97": "Udupi",
      "207": "Bellary",
      "229": "Davangere",
      "249": "Hassan",
      "346": "Dharwad",
      "394": "Chitradurga",
      "473": "Bidar",
      "480": "Gadag",
      "498": "Kolar",
      "499": "Koppal",
      "506": "Mandya",
      "520": "Raichur",
      "560": "Bagalkot",
      "594": "Chamrajnagar",
      "600": "Chickmagalur",
      "607": "Dakshina Kannada",
      "651": "Haveri",
      "698": "Kodagu",
      "784": "Ramanagar",
      "843": "Uttara Kannada",
      "903": "Chikkaballapur",
      "1099": "Yadgir",
      "10045": "Bangalore Rural"
    }
  },
  "18": {
    state_id: "18",
    state_name: "Kerala",
    cities: {
      "59": "Kottayam",
      "72": "Palakkad",
      "141": "Kannur",
      "181": "Thrissur",
      "183": "Trivandrum",
      "193": "Alappuzha",
      "234": "Ernakulam",
      "265": "Kollam",
      "270": "Malappuram",
      "297": "Pathanamthitta",
      "316": "Thiruvananthapuram",
      "366": "Kozhikode",
      "496": "Kasargod",
      "652": "Idukki",
      "847": "Wayanad"
    }
  },
  "19": {
    state_id: "19",
    state_name: "Lakshadweep",
    cities: {
      "455": "Lakshadweep" 
    }
  },
  "20": {
    state_id: "20",
    state_name: "Madhya Pradesh",
    cities: {
      "33": "Chhindwara",
      "43": "Gwalior",
      "48": "Indore",
      "57": "Khargone",
      "79": "Ratlam",
      "115": "Bhopal",
      "134": "Jabalpur",
      "171": "Sagar",
      "174": "Satna",
      "245": "Guna",
      "250": "Hoshangabad",
      "263": "Khandwa",
      "321": "Ujjain",
      "341": "Sidhi",
      "452": "Shahdol",
      "477": "Dewas",
      "556": "Anuppur",
      "562": "Balaghat",
      "573": "Barwani",
      "576": "Betul",
      "578": "Bhind",
      "599": "Chhatarpur",
      "608": "Damoh",
      "611": "Datia",
      "617": "Dhar",
      "623": "Dindori",
      "649": "Harda",
      "662": "Jhabua",
      "684": "Katni",
      "730": "Mandla",
      "731": "Mandsaur",
      "741": "Morena",
      "749": "Narsinghpur",
      "751": "Neemuch",
      "762": "Panna",
      "781": "Raisen",
      "783": "Rajgarh",
      "787": "Rewa",
      "802": "Sehore",
      "804": "Seoni",
      "808": "Shajapur",
      "811": "Sheopur",
      "812": "Shivpuri",
      "832": "Tikamgarh",
      "840": "Umaria",
      "846": "Vidisha",
      "1542": "Ashok Nagar",
      "1549": "Singrauli",
      "10029": "East Nimar",
      "10033": "West Nimar"
    }
  },
  "21": {
    state_id: "21",
    state_name: "Maharashtra",
    cities: {
      "15": "Mumbai",
      "16": "Pune",
      "19": "Akola",
      "50": "Jalgaon",
      "67": "Nagpur",
      "68": "Nashik",
      "85": "Satara",
      "103": "Ahmednagar",
      "107": "Amravati",
      "110": "Aurangabad-Maharashtra",
      "111": "Beed",
      "122": "Dhule",
      "144": "Kolhapur",
      "146": "Latur",
      "155": "Nanded",
      "168": "Ratnagiri",
      "173": "Sangli",
      "178": "Solapur",
      "222": "Chandrapur",
      "315": "Thane",
      "326": "Yavatmal",
      "358": "Parbhani",
      "361": "Wardha",
      "398": "Washim",
      "399": "Buldhana",
      "472": "Bhandara",
      "483": "Gondia",
      "485": "Hingoli",
      "489": "Jalna",
      "512": "Nandurbar",
      "527": "Sindhudurg",
      "635": "Gadchiroli",
      "758": "Osmanabad",
      "947": "Jalgaon",
      "10046": "Raigarh"
    }
  },
  "22": {
    state_id: "22",
    state_name: "Manipur",
    cities: {
      "252": "Imphal",
      "582": "Bishnupur",
      "596": "Chandel",
      "604": "Churachandpur",
      "803": "Senapati",
      "827": "Tamenglong",
      "831": "Thoubal",
      "839": "Ukhrul"
    }
  },
   "23": {
    state_id: "23",
    state_name: "Meghalaya",
    cities: {
      "630": "East Khasi Hills",
      "653": "Jaintia Hills",
      "788": "Ri Bhoi",
      "1070": "South Garo Hills",
      "1097": "West Garo Hills",
      "1098": "West Khasi Hills"
    }
  },
   "24": {
    state_id: "24",
    state_name: "Mizoram",
    cities: {
      "18": "Aizwal",
      "593": "Champhai",
      "701": "Kolasib",
      "713": "Lawngtlai",
      "719": "Lunglei",
      "729": "Mammit",
      "794": "Saiha",
      "806": "Serchhip"
    }
  },
   "25": {
    state_id: "25",
    state_name: "Nagaland",
    cities: {
      "37": "Dimapur",
      "362": "Kohima",
      "696": "Kiphire",
      "716": "Longleng",
      "738": "Mokokchung",
      "739": "Mon",
      "769": "Peren",
      "770": "Phek",
      "837": "Tuensang",
      "853": "Wokha",
      "854": "Zunhebotto"
    }
  },
   "26": {
    state_id: "26",
    state_name: "Orissa",
    cities: {
      "84": "Sambalpur",
      "109": "Angul",
      "226": "Cuttack",
      "469": "Bargarh",
      "487": "Jagatsinghpur",
      "488": "Jajpur",
      "497": "Kendrapara",
      "518": "Puri",
      "563": "Balangir",
      "564": "Baleswar",
      "577": "Bhadrak",
      "583": "Boudh",
      "613": "Debagarh",
      "619": "Dhenkanal",
      "636": "Gajapati",
      "639": "Ganjam",
      "664": "Jharsuguda",
      "670": "Kalahandi",
      "672": "Kandhamal",
      "687": "Kendujhar",
      "693": "Khorda",
      "702": "Koraput",
      "728": "Malkangiri",
      "735": "Mayurbhanj",
      "744": "Nabarangapur",
      "750": "Nayagarh",
      "756": "Nuapada",
      "786": "Rayagada",
      "819": "Sonapur",
      "824": "Sundergarh"
    }
  },
   "27": {
    state_id: "27",
    state_name: "Pondicherry",
    cities: {
      "457": "Pondicherry",
      "677": "Karaikal"
    }
  },
  "28": {
    state_id: "28",
    state_name: "Punjab",
    cities: {
      "5": "Ludhiana",
      "22": "Amritsar",
      "64": "Mohali",
      "74": "Pathankot",
      "113": "Bathinda",
      "132": "Hoshiarpur",
      "162": "Patiala",
      "238": "Ferozepur",
      "276": "Moga",
      "290": "Nawanshahr",
      "302": "Rupnagar",
      "306": "Sangrur",
      "423": "Ropar",
      "429": "Barnala",
      "432": "Gurdaspur",
      "478": "Faridkot",
      "495": "Kapurthala",
      "508": "Muktsar",
      "633": "Fatehgarh Sahib",
      "732": "Mansa",
      "926": "Fazilka",
      "1079": "Tarn Taran",
      "1545": "Firozpur"
    }
  },
  "29": {
    state_id: "29",
    state_name: "Rajasthan",
    cities: {
      "30": "Bhilwara",
      "49": "Jaipur",
      "53": "Jodhpur",
      "104": "Ajmer",
      "106": "Alwar",
      "117": "Bikaner",
      "145": "Kota",
      "154": "Nagaur",
      "176": "Sikar",
      "185": "Udaipur",
      "199": "Banswara",
      "223": "Chittaurgarh",
      "293": "Pali",
      "338": "Bharatpur",
      "449": "Rajsamand",
      "484": "Hanumangarh",
      "491": "Jhalawar",
      "569": "Baran",
      "571": "Barmer",
      "586": "Bundi",
      "605": "Churu",
      "612": "Dausa",
      "620": "Dholpur",
      "625": "Dungarpur",
      "637": "Ganganagar",
      "654": "Jaisalmer",
      "656": "Jalor",
      "665": "Jhujhunu",
      "678": "Karauli",
      "800": "Sawai Madhopur",
      "817": "Sirohi",
      "836": "Tonk"
    }
  },
  "30": {
    state_id: "30",
    state_name: "Sikkim",
    cities: {
      "40": "Gangtok"
    }
  },
  "31": {
    state_id: "31",
    state_name: "Tamil Nadu",
    cities: {
      "13": "Chennai",
      "34": "Coimbatore",
      "61": "Madurai",
      "92": "Thanjavur",
      "96": "Tuticorin",
      "99": "Vellore",
      "124": "Erode",
      "172": "Salem",
      "182": "Tiruchirapalli",
      "225": "Cuddalore",
      "231": "Dindigul",
      "286": "Namakkal",
      "318": "Tirunelveli",
      "370": "Nagapattinam",
      "372": "Ariyalur",
      "373": "Tiruvarur",
      "374": "Kanyakumari",
      "384": "Sivagangai",
      "389": "Ramanathapuram",
      "395": "Villupuram",
      "408": "Karur",
      "409": "Thiruvannamalai",
      "494": "Kanchipuram",
      "500": "Krishnagiri",
      "540": "Virudhunagar",
      "752": "Nilgiris",
      "768": "Perambalur",
      "776": "Pudukkottai",
      "835": "Tiruvallur",
      "1030": "Theni",
      "1415": "Sivaganga",
      "1448": "Tiruvannamalai",
      "1547": "Dharmapuri"
    }
  },
  "32": {
    state_id: "32",
    state_name: "Tripura",
    cities: {
      "17": "Agartala",
      "615": "Dhalai",
      "1548": "Tripura"
    }
  },
  "33": {
    state_id: "33",
    state_name: "Uttarakhand",
    cities: {
      "121": "Dehradun",
      "248": "Haridwar",
      "421": "Almora",
      "561": "Bageshwar",
      "591": "Chamoli",
      "592": "Champawat",
      "745": "Nainital",
      "767": "Pauri Garhwal",
      "772": "Pithoragarh",
      "790": "Rudraprayag",
      "829": "Tehri Garhwal",
      "838": "Udham Singh Nagar",
      "844": "Uttarkashi"
    }
  },
  "34": {
    state_id: "34",
    state_name: "Uttar Pradesh",
    cities: {
      "7": "Lucknow",
      "20": "Allahabad",
      "41": "Ghaziabad",
      "56": "Kanpur",
      "71": "Noida",
      "83": "Saharanpur",
      "102": "Agra",
      "105": "Aligarh",
      "127": "Gorakhpur",
      "138": "Jhansi",
      "150": "Meerut",
      "151": "Moradabad",
      "187": "Varanasi",
      "198": "Azamgarh",
      "203": "Bareilly",
      "205": "Basti",
      "214": "Bijnor",
      "235": "Etawah",
      "236": "Faizabad",
      "247": "Hamirpur",
      "256": "Jaunpur",
      "275": "Mirzapur",
      "282": "Muzaffarnagar",
      "307": "Shahjahanpur",
      "312": "Sonebhadra",
      "332": "Mathura",
      "343": "Farrukhabad",
      "348": "Greater Noida",
      "354": "Sitapur",
      "376": "Sultanpur",
      "386": "Baghpat",
      "392": "Barabanki",
      "422": "Bahraich",
      "446": "Hardoi",
      "459": "Bulandshahr",
      "465": "Ballia",
      "479": "Firozabad",
      "482": "Gonda",
      "503": "Kushinagar",
      "505": "Mahoba",
      "517": "Pratapgarh",
      "524": "Rampur",
      "536": "Unnao",
      "553": "Ambedkar Nagar",
      "558": "Auraiya",
      "566": "Balrampur",
      "567": "Banda",
      "584": "Budaun",
      "595": "Chandauli",
      "602": "Chitrakoot",
      "614": "Deoria",
      "632": "Etah",
      "634": "Fatehpur",
      "641": "Gautam Buddha Nagar",
      "642": "Ghazipur",
      "650": "Hathras",
      "655": "Jalaun",
      "666": "Jyotiba Phule Nagar",
      "675": "Kannauj",
      "685": "Kaushambi",
      "690": "Kheri",
      "711": "Lalitpur",
      "722": "Maharajganj",
      "727": "Mainpuri",
      "734": "Mau",
      "771": "Pilibhit",
      "780": "Raebareli",
      "796": "St Kabir Nagar",
      "797": "Sant Ravidas Nagar",
      "813": "Shrawasti",
      "814": "Siddharth Nagar",
      "1062": "Sant Kabir Nagar",
      "10047": "Kanpur Dehat"
    }
  },
  "35": {
    state_id: "35",
    state_name: "West Bengal",
    cities: {
      "58": "Kolkata",
      "62": "Malda",
      "120": "Coochbehar",
      "201": "Barddhman",
      "251": "Howrah",
      "274": "Midnapore",
      "363": "Birbhum",
      "466": "Bankura",
      "476": "Darjeeling",
      "486": "Hooghly",
      "490": "Jalpaiguri",
      "743": "Murshidabad",
      "754": "24 Parganas",
      "755": "Dinajpur",
      "778": "Puruliya",
      "1003": "Nadia"
    }
  },
  "36": {
    state_id: "36",
    state_name: "Telangana",
    cities: {
      "14": "Hyderabad",
      "142": "Karim Nagar",
      "158": "Nizamabad",
      "189": "Warangal",
      "285": "Nalgonda",
      "439": "Khammam",
      "461": "Adilabad",
      "667": "Rangareddy",
      "736": "Medak",
      "1285": "Mahabub Nagar",
      "10048": "Patancheru"
    }
  }
};


/** Cities for Apply New when getCity API is unavailable */
export function getCitiesForState(stateId) {
  const entry = STATE_CITY[String(stateId)];
  if (!entry?.cities) return [];

  return Object.entries(entry.cities)
    .map(([city_id, city]) => ({ city_id: String(city_id), city }))
    .sort((a, b) => a.city.localeCompare(b.city));
}

export default STATE_CITY;
